import moment from 'moment/moment';

const xAxisFormatter = (timestamp: moment.Moment | string) => {
    return typeof timestamp === 'object' ? timestamp.format('MMM DD YYYY') : moment(timestamp).format('MMM DD YYYY');
};

export { xAxisFormatter };
